import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { POPUP_TYPE_PROFFIT_SEARCH_FIRST_VIEW } from '@/utils/constants/popup/eventType';
const ProffitSearchTutorialHoc = () => (ChildComponent) => {
    const ProffitSearchTutorialHocInner = (props) => {
        const profile = useSelector((state) => state.profile);
        const popups = useSelector((state) => state.popup);
        const { isShowSearchFirstView } = useMemo(() => {
            const { viewPopups } = profile || {};
            return {
                isShowSearchFirstView: popups.accessEvent[POPUP_TYPE_PROFFIT_SEARCH_FIRST_VIEW]
                    ? false
                    : (viewPopups || []).includes(POPUP_TYPE_PROFFIT_SEARCH_FIRST_VIEW),
            };
        }, [profile, popups.accessEvent]);
        if (isShowSearchFirstView) {
            return _jsx(CustomRedirect, { to: '/proffit_search' });
        }
        return _jsx(ChildComponent, Object.assign({}, props));
    };
    ProffitSearchTutorialHocInner.propTypes = {};
    return ProffitSearchTutorialHocInner;
};
export default ProffitSearchTutorialHoc;
